import { render, staticRenderFns } from "./RelationtItem.vue?vue&type=template&id=3037f556&scoped=true&lang=true"
import script from "./RelationtItem.vue?vue&type=script&lang=js"
export * from "./RelationtItem.vue?vue&type=script&lang=js"
import style0 from "./RelationtItem.vue?vue&type=style&index=0&id=3037f556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3037f556",
  null
  
)

export default component.exports